import { materias } from '../../assets/images'

// TODO: cambiar las imagenes
export const CONFIGURATION_IMAGE_CARD = {
  ESPACIO_CURRICULAR: materias.biologia,
  USUARIOS: materias.fallback,
  APROBACION_ROLES: materias.fallback,
}
